import React from "react";
import { Form, Label } from "semantic-ui-react";
import NumberFormat from "react-number-format";

const NumberInput = ({
  input,
  width,
  maxLength,
  handleOnChange,
  disabled,
  meta: { touched, error },
  decimalScale = "2",
}) => {
  return (
    <Form.Field error={touched && !!error} width={width}>
      <NumberFormat
        value={input.value}
        thousandSeparator=""
        maxLength={maxLength}
        disabled={disabled}
        decimalScale={decimalScale}
        fixedDecimalScale={false}
        allowNegative={false}
        autoComplete="off"
        onBlur={(e) => {
          input.onBlur(e.target.value);
        }}
        onValueChange={({ formattedValue }) => {
          if (handleOnChange) handleOnChange(formattedValue);
          input.onChange(formattedValue);
        }}
      />
      {touched && error && (
        <Label pointing basic color="red">
          {error}
        </Label>
      )}
    </Form.Field>
  );
};

export default NumberInput;
